import { IPlayerState } from '../reducer.types';
import { setCurrentlyPlayingTrackId } from '../actions';

export const setCurrentlyPlayingTrackIdReducer = (
  state: IPlayerState,
  action: ReturnType<typeof setCurrentlyPlayingTrackId>,
) => ({
  ...state,
  currentlyPlayingTrackId: action.payload.id,
  durationPlayedInPermille: 0,
});
